// useMPGS.js

import { useRef } from 'react';

import { mpgsBridge } from './mpgsCallbackBridge';

const showOverlay = () => {
  const overlay = document.getElementById('mpgs-overlay');
  if (overlay) {
    overlay.style.display = 'block';
  }
};

const hideOverlay = () => {
  const overlay = document.getElementById('mpgs-overlay');
  if (overlay) {
    overlay.style.display = 'none';
  }
  const checkout = document.getElementById('checkout-container');
  if (checkout) {
    checkout.innerHTML = '';
  }
};

export const useMPGS = (callbacks) => {
  const payingRef = useRef(false);

  const init = () => {
    mpgsBridge.setCallbacks({
      ...callbacks,
      onError: (e) => {
        payingRef.current = false;
        hideOverlay();
        callbacks.onError?.(e);
      },
      onCancel: () => {
        payingRef.current = false;
        hideOverlay();
        callbacks.onCancel?.();
      },
      onComplete: (res) => {
        payingRef.current = false;
        hideOverlay();
        callbacks.onComplete?.(res);
      },
    });

    mpgsBridge.init();
  };

  const pay = (sessionId, container) => {
    if (payingRef.current) return;
    payingRef.current = true;
    showOverlay();

    window.Checkout.configure({
      session: { id: sessionId },
    });

    window.Checkout.showEmbeddedPage(container);
  };

  return {
    init,
    pay,
    hideOverlay,
    isPaying: () => payingRef.current,
  };
};
